import { render, staticRenderFns } from "./yqglcompxq.vue?vue&type=template&id=081d215a&scoped=true&"
import script from "./yqglcompxq.vue?vue&type=script&lang=js&"
export * from "./yqglcompxq.vue?vue&type=script&lang=js&"
import style0 from "./yqglcompxq.vue?vue&type=style&index=0&id=081d215a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d215a",
  null
  
)

export default component.exports